import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { KLoaderComponent } from '@shared/components/k-loader/k-loader.component';
import { KToastComponent } from '@shared/components/k-toast/k-toast.component';
import { ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, KLoaderComponent, KToastComponent],
  templateUrl: './app.html',
})
export class App {
  protected readonly theme = inject(ThemeService);
}
